/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { MenuData, MenuLevel, MenuLevelExtra } from './models';
import _get from 'lodash/get';

class LevelDoesNotExistsError extends Error {
    constructor(path: number[]) {
        super(`Level with path [${path.join(', ')}] does not exists!`);
    }
}

export function getLevel(data: MenuData, path: number[]): MenuLevel {
    if (path.length < 1) throw new Error(`Cannot get level for path '${path.toString()}'`);
    let current: MenuLevel = data[path[0]!]!;
    if (!current) throw new LevelDoesNotExistsError(path);
    for (let i = 1; i < path.length; i++) {
        const segment = path[i]!;
        if (!Array.isArray(current.children)) throw new LevelDoesNotExistsError(path);
        if (!current.children[segment]) throw new LevelDoesNotExistsError(path);
        current = current.children[segment]!;
    }

    return current;
}

export function coerceExtraPath(data: MenuData, activePath: number[]): number[] {
    activePath = activePath.slice(0);
    if (activePath.length < 1) return activePath;
    if (typeof activePath[0] !== 'number') return activePath;

    while (activePath.length) {
        const level = _get(data, activePath.join('.children.'));
        if (level.extra) return activePath;
        activePath = activePath.slice(0, -1);
    }

    return [];
}

export function extraDepthSearch(data: MenuData, path: number[]): number[] | null {
    const level = _get(data, path.join('.children.'));

    if (level.extra) {
        return path;
    }

    if (level.children && level.children.length) {
        for (let i = 0; i < level.children.length; i++) {
            const res = extraDepthSearch(data, [...path, i]);
            if (res) return res;
        }
    }

    return null;
}

function isLevelMenu(data: MenuData, subtreeIndex: number): boolean {
    return data[subtreeIndex!]!.viewMode === '3steps_menu';
}

export function getFirstExtraPath(data: MenuData, subtreeIndex: number): number[] {
    return isLevelMenu(data, subtreeIndex)
        ? [subtreeIndex, 0]
        : extraDepthSearch(data, [subtreeIndex]) || [subtreeIndex];
}

export function getExtra(data: MenuData, activePath: number[]): MenuLevelExtra | null {
    return _get(data, coerceExtraPath(data, activePath).join('.children.'))?.extra || null;
}
